// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const ShareIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        d="M7.65 11.05c.2.36.58.55.96.55q.29 0 .55-.15l6.79-3.96c.53-.3.7-.98.4-1.5-.31-.53-.99-.71-1.51-.4L8.05 9.53c-.53.31-.7.99-.4 1.51m7.2 7.38q.26.15.55.15c.38 0 .75-.2.96-.55.3-.53.13-1.2-.4-1.51l-6.8-3.96c-.52-.3-1.2-.13-1.5.4-.31.52-.14 1.2.4 1.5z"
        opacity=".5"
      />
      <path d="M14.43 5.04c0 1.95 1.59 3.53 3.54 3.53S21.5 7 21.5 5.04 19.9 1.5 17.97 1.5c-1.95 0-3.54 1.59-3.54 3.54M2.5 12c0 1.95 1.58 3.54 3.53 3.54S9.57 13.95 9.57 12 7.98 8.46 6.03 8.46 2.5 10.06 2.5 12m11.93 6.96c0 1.95 1.59 3.54 3.54 3.54s3.54-1.59 3.54-3.54-1.6-3.53-3.54-3.53c-1.95 0-3.54 1.58-3.54 3.53" />
    </g>
  </SvgIcon>
);

export default ShareIcon;
